import { useCanGoBack, useNavigate, useRouter } from '@tanstack/react-router';
import { Button, ErrorPage } from '@thisisdmg/tirecloud-patterns/v2';
import { useTranslation } from 'react-i18next';

export default function Error404() {
  const { t } = useTranslation();
  const router = useRouter();
  const navigate = useNavigate();
  const canGoBack = useCanGoBack();

  return (
    <ErrorPage
      code={[4, 0, 4]}
      title={t('errors.not_found_title')}
      description={t('errors.not_found_description')}
      actionButtons={
        <div className="tc:inline-flex tc:gap-x-2">
          <Button.Solid
            color="brand"
            onClick={() => {
              if (canGoBack) {
                router.history.back();
              } else {
                navigate({
                  to: '/',
                  search: { ref: 'not_found' },
                  replace: true,
                });
              }
            }}
          >
            {t('common.backToPreviousPage')}
          </Button.Solid>
        </div>
      }
    />
  );
}
